import styled from 'styled-components';
import { Stack } from '@mui/material';
import SelectedConversationMessageList from './SelectedConversationMessageList';
import { useGetTwilioConversationById, ConversationType } from '@vs-online-only-app/state';

import MessageComposer from '../message-composer/MessageComposer';
import SelectedConversationShopperProfile from './SelectedConversationShopperProfile';
import { useSelectedHeroConversation } from '../../hooks/useSelectedHeroConversation';
import SelectedActiveConversationHeader from './SelectedActiveConversationHeader';
import { SelectedArchivedConversationHeader } from './SelectedArchivedConversationHeader';
import SmartResponses from './smart-responses/SmartResponses';

const SectionWrapper = styled.div`
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: auto 1fr;
  overflow: auto;
`;

const IsolatedConversationSectionWrapper = styled(Stack)`
  padding: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledSelectedConversationMessageList = styled(SelectedConversationMessageList)`
  flex-grow: 1;
  overflow: auto;
`;

const LiveChatWrapper = styled(Stack)`
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 3, 4, 3)};
  overflow: auto;
  box-sizing: border-box;
  position: relative;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const SelectedConversationSection = () => {
  const selectedHeroConversation = useSelectedHeroConversation();
  const { data: selectedTwilioConversation } = useGetTwilioConversationById(
    selectedHeroConversation?.twilioConversationId
  );

  if (
    !selectedHeroConversation ||
    selectedTwilioConversation?.status !== 'joined'
  ) {
    return null;
  }

  const { source } = selectedHeroConversation;
  if (source === ConversationType.Contact) {
    return (
      <IsolatedConversationSectionWrapper>
        <StyledSelectedConversationMessageList />
        <SmartResponses />
        {!selectedHeroConversation.archiveAttributes && <MessageComposer />}
      </IsolatedConversationSectionWrapper>
    );
  }

  return (
    <SectionWrapper>
      {selectedHeroConversation.archiveAttributes ? (
        <SelectedArchivedConversationHeader />
      ) : (
        <SelectedActiveConversationHeader />
      )}
      <LiveChatWrapper>
        <SelectedConversationMessageList />
        <SmartResponses />
        {!selectedHeroConversation.archiveAttributes && <MessageComposer />}
      </LiveChatWrapper>
      <SelectedConversationShopperProfile />
    </SectionWrapper>
  );
};
export default SelectedConversationSection;
